import { debugLog } from "@lululemon/auth-common";
import { cleanup } from "./load-shape-scripts";
export function initializeJsReadyListener(_a) {
    var timeout = _a.timeout, logger = _a.logger;
    debugLog({ message: "Setting JSReady listener", level: "debug" });
    return new Promise(function (resolve) {
        var jsReadyTimeout;
        var onJsReady = function () {
            clearTimeout(jsReadyTimeout);
            window.removeEventListener("JSReady", onJsReady);
            debugLog({ message: "JSReady event is received", level: "debug" });
            resolve({ cleanup: cleanup });
        };
        jsReadyTimeout = setTimeout(function () {
            window.removeEventListener("JSReady", onJsReady);
            debugLog({ message: "JSReady event is timed out", level: "debug" });
            logger === null || logger === void 0 ? void 0 : logger.error(new Error("JSReady event is timed out"), {
                tags: {
                    componentName: "shape",
                    featureName: "createJsReadyPromise"
                }
            });
            resolve({ cleanup: cleanup });
        }, timeout);
        window.addEventListener("JSReady", onJsReady);
    });
}
